import React, { useEffect, useState, Fragment, useContext } from 'react';
import FieldDisplay from 'field/display/FieldDisplay';
import LocaleContext from 'constants/localization';
import LocalizedStrings from 'react-localization';
import API from 'constants/api';
import { SPECTRUM } from 'constants/predicates';
import { actionSuccess, actionError } from 'helpers/actionHelpers';
import { useSelector, connect } from 'react-redux';
import { openStatementCommentModal } from 'actions/modalActions';


const StatementDisplay = ({ field, openStatementCommentModal }) => {
  return (
    <Fragment>
      <p>{field.label}</p>
      {
        field.values.map((value, i) => (
          <div className={'mdrow'} key={i}>
            <Attachment value={value} openStatementCommentModal={openStatementCommentModal}/>
          </div>
        ))
      }
    </Fragment>
  );
}

const Attachment = ({value, openStatementCommentModal}) => {
  const LS = useContext(LocaleContext);
  strings.setLanguage(LS.getLanguage());
  const { uri, fields } = value;
  if (!fields) {
    return null;
  }
  
  const [signDisabled, setSignDisabled] = useState(false); 
  const [sendMailDisabled, setSendMailDisabled] = useState(false); 
  const [archiveStatementDisabled, setArchiveStatementDisabled] = useState(false); 
  
  const [isDemonstrator, setIsDemonstrator] = useState(false); 
  const [isSolver, setIsSolver] = useState(false); 
  const [myLogin, setMyLogin] = useState(null); 
  
  const { fileName, mimeType, attachmentType, 
    primaryDocument, readiness, description, isIndexed, documentType, solverSigned, demonstratorSigned, statementPosted, demonstrator, solver, signatureRequestStatus } = fields;

  const [demonstratorSignedString, setDemonstratorSignedString] = useState(strings.demonstrator+strings.notSigned);
  const [solverSignedString, setSolverSignedString] = useState(strings.solver+strings.notSigned);
  const [statusString, setStatusString] = useState(null);
  
  const [signatureRequestStatusValue, setSignatureRequestStatusValue] = useState(signatureRequestStatus != null && signatureRequestStatus.values[0]);
  const [solverHasSigned, setSolverHasSigned] = useState(solverSigned != null && solverSigned.values[0]);
  const [demonstratorHasSigned, setDemonstratorHasSigned] = useState(demonstratorSigned != null && demonstratorSigned.values[0]);
  const [statementIsPosted, setStatementIsPosted] = useState(statementPosted != null && statementPosted.values[0]);
  
  const [isArchived, setIsArchived] = useState(readiness != null && readiness.values[0] === "Käsitelty");
  const [isSignableStatement, setIsSignableStatement] = useState(documentType != null && documentType.values[0].uri === "http://www.profium.com/spectrum/ce/StatementDocumentTypeList#statement");
  
  // Disable sign button if status is this
  const disableSignStatuses = ["RejectedByPresenter","RejectedBySolver","PresenterSATUDoesNotMatch","SolverSATUDoesNotMatch","PresenterAndSolverSATUDoNotMatch"];
  
  useEffect(() => {
    if(solverHasSigned){
		setSolverSignedString(strings.solver+strings.signed);
  	}else{
		setSolverSignedString(strings.solver+strings.notSigned);
	}
  },[solverHasSigned]);
  
  useEffect(() => {
    if(demonstratorHasSigned){
		setDemonstratorSignedString(strings.demonstrator+strings.signed);
  	}else{
		setDemonstratorSignedString(strings.demonstrator+strings.notSigned);
	}
  },[demonstratorHasSigned]);
  
  useEffect(() => {
    if(signatureRequestStatusValue == "PresenterSigned"){
	  setDemonstratorHasSigned(true);
    }else if(signatureRequestStatusValue == "SolverSigned"){
	  setSolverHasSigned(true);
	}else{
	   if(disableSignStatuses.includes(signatureRequestStatusValue)){
	 		setSignDisabled(true);
		}
	   setStatusString(createStatusString(signatureRequestStatusValue));
    }
  },[signatureRequestStatusValue]);
  
  useEffect(() => {
	setStatusString(createStatusString(signatureRequestStatusValue));
	if(!myLogin){
    	getLogin();
    }
  },[]);
  
  const getLogin = () => {
    let url = API.CE + '/getLogin';
    return fetch(url, {
    })
      .then(res => res.json())
      .then(json => {
		if(json.login){
			setMyLogin(json.login);
			setIsDemonstrator(checkUsernameMatch(json.login, demonstrator));
		    setIsSolver(checkUsernameMatch(json.login, solver));
		}
      });
  };
  
  const createStatusString = (value) => {
	if(value){
		if(signatureRequestStatusValue == "Open" || signatureRequestStatusValue == "Complete" ){
			// We agreed that this info might not be useful display
			return "";
		}else{
			return strings.status[value];
		}
	}else{
		return "";
	}
  }
  
  const ImagePreview = () => {
    let src = '';

    if (mimeType && mimeType.values[0].startsWith('image')) {
      src = `${API.DAM.DISPLAY_CONTENT}?uri=${uri}&type=thumb`;
    } else {
      src = 'images/NoImage.jpg';
    }
    return <img src={src} />;
  };

  const mailStatement = () => {
	 setSendMailDisabled(true);
	 let url = `${API.CE}/sendStatementEmail?uri=${uri}`;
		fetch(url,
  	      {
  	        method: 'POST'
  	      })
		.then(res => res.json())
		.then(json => {
				if (json.success) {
					createNotification(strings.statementMailSent);
					setStatementIsPosted(true);
				}
				else {
					actionError({message: "couldNotSendMail"});
				}
			}).catch(e => {
				console.log(e);
				actionError({message: "couldNotSendMail"});
			});
  }
  
  /**
   * Checks if the given username matches the User field login value
   */
  const checkUsernameMatch = (userName, userField) => {
	let userNamesmatch = false;
	if(userField != null && userField.values.length > 0){
		const userObject = userField.values[0];
		if(userObject.fields.length > 0){
			for(const idx in userObject.fields){
				var field = userObject.fields[idx];
				if(field.predicate === "http://www.profium.com/imagearchive/2007/login" 
					&& field.values.length > 0 && field.values[0] === userName){
					userNamesmatch = true;
					break;
				}
			}
		}
	}
	return userNamesmatch;
  }
  
  /**
   Poll signature request status
   */
  const pollSignatureRequestStatus = () => {
	setTimeout(() => {
	  let url = `${API.SIGNATURE}/getSignatureStatus?uri=${uri}`;
		fetch(url,
  	      {
  	        method: 'GET'
  	      })
		.then(res => res.json())
		.then(json => {
				if (json.status) {
					if(json.status != signatureRequestStatusValue){
						setSignatureRequestStatusValue(json.status);
					}else{
						pollSignatureRequestStatus();
					}
				}
			}).catch(e => {
				console.log(e);
			});
	}, 1500);
  }
  
  const signStatement = (role) => {
	 setSignDisabled(true);
	  let url = `${API.SIGNATURE}/doSigning?uri=${uri}`;
		fetch(url,
  	      {
  	        method: 'POST'
  	      })
		.then(res => res.json())
		.then(json => {
				if (json.link) {
					pollSignatureRequestStatus();
					window.open(json.link, '_blank');
				}
				else {
					actionError({message: 'couldNotSign'});
				}
			}).catch(e => {
				console.log(e);
				actionError({message: 'couldNotSign'});
			});
  }
  
  const sendMessageToSolver = () => {
	 let url = `${API.CE}/sendMessageToSolver?uri=${uri}`;
		fetch(url,
  	      {
  	        method: 'POST'
  	      })
		.then(res => res.json())
		.then(json => {
				if (json.success) {
					createNotification(strings.messageToSolverSent);
				}
				else {
					actionError({message: "messageToSolverCouldNotBeSent"});
				}
			}).catch(e => {
				console.log(e);
				actionError({message: "messageToSolverCouldNotBeSent"});
			});
  }
  
  const sendMessageToDemonstrator = (comment) => {
	let url = `${API.CE}/sendMessageToDemonstrator?uri=${uri}`;
	fetch(url,
      {
        method: 'POST',
        headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({comment: comment })
      })
	.then(res => res.json())
	.then(json => {
			if (json.success) {
				createNotification(strings.messageToDemonstratorSent);
			}
			else {
				actionError({message: "messageToDemonstratorCouldNotBeSent"});
			}
		}).catch(e => {
			console.log(e);
			actionError({message: "messageToDemonstratorCouldNotBeSent"});
		});
  }
  
  const openModal = () => openStatementCommentModal({
    label: `${LS.statement.statementSolverComment}`,
    onSave: sendCommentMessageToDemonstrator
  });
  
  const sendCommentMessageToDemonstrator = (value) =>{
	if(value){
		sendMessageToDemonstrator(value);
	}
  }
  
   const archiveStatement = () => {
	 setArchiveStatementDisabled(true);
	 let url = `${API.CE}/archiveStatement?uri=${uri}`;
		fetch(url,
  	      {
  	        method: 'POST'
  	      })
		.then(res => res.json())
		.then(json => {
				if (json.success) {
					createNotification(strings.statementArchived);
					setIsArchived(true);
					setSignatureRequestStatusValue("StatementArchived");
				}
				else {
					actionError({message: "couldNotArchiveStatement"});
				}
			}).catch(e => {
				console.log(e);
				actionError({message: "couldNotArchiveStatement"});
			}); 
  }
  

  return (
    <div className='resource digital-content flex-left'>
      <ImagePreview />
      <div style={{marginLeft: '2rem'}}>
        <p>
          <a style={{fontSize: '18px'}} target="_blank" 
            href={`${API.DAM.DISPLAY_ATTACHMENT}&uri=${uri}`}>
            {LS.downloadFile}
          </a>
        </p>
        {isSignableStatement && <div>
        <p>{demonstratorSignedString }</p>
        <p>{solverSignedString }</p>
        </div>}
        <p>{statusString}</p> 
        <FieldDisplay field={fileName} />
        <FieldDisplay field={attachmentType} />
        <FieldDisplay field={primaryDocument} />
        <FieldDisplay field={description} />
        <FieldDisplay field={isIndexed} />
        {((isDemonstrator || isSolver) && !isSignableStatement && !isArchived) &&
       		<button 
              className="archive-statement" 
              disabled={archiveStatementDisabled}
              type="button"
              onClick={archiveStatement}>
              <i class="fa fa-archive"/> {strings.archiveWithoutSignature}
            </button>
        }
        {(solverHasSigned && demonstratorHasSigned && !statementIsPosted && isSignableStatement) && 
        	<button 
              className="mail-statement" 
              disabled={sendMailDisabled}
              type="button"
              onClick={mailStatement}>
              <i class="fa fa-paper-plane"/> {LS.statement.mailStatement}
            </button>
        }
        {
		  statementIsPosted &&
		  <p>{strings.posted}</p>
        }
        {(!solverHasSigned && !demonstratorHasSigned && isDemonstrator && isSignableStatement) && 
        	<button  
              className="sign-statement" 
              type="button"
              disabled={signDisabled}
              onClick={() => signStatement("demonstrator")}>
              <i class="fa fa-pencil-square-o"/> {strings.signStatement}
            </button>
        }
        {((!solverHasSigned && !demonstratorHasSigned && isDemonstrator && isSignableStatement) || (isDemonstrator && !isSignableStatement && !isArchived) )&&
				<>
				<br/>
		            <button  
		              className="send-message-to-solver" 
		              type="button"
		              onClick={sendMessageToSolver}>
		              <i class="fa fa-envelope-o"/> {strings.sendMessageToSolver}
		            </button>
	            </>
		}
        {(!solverHasSigned && demonstratorHasSigned && isSolver && isSignableStatement) && 
        	<button 
              className="sign-statement" 
              type="button"
              disabled={signDisabled}
              onClick={() => signStatement("solver")}>
              <i class="fa fa-pencil-square-o"/> {strings.signStatement}
            </button>
        }
        {((!solverHasSigned && isSolver && isSignableStatement) || (isSolver && !isSignableStatement && !isArchived)) && 
        	<>
	        	<br/>
	            <button  
	              className="send-message-to-demonstrator" 
	              type="button"
	              onClick={() => sendMessageToDemonstrator(null)}>
	              <i class="fa fa-envelope-o"/> {strings.sendMessageToDemonstrator}
	            </button>
	            <br/>
	            <button  
	              className="send-message-to-demonstrator-with-comment" 
	              type="button"
	              onClick={openModal}>
	              <i class="fa fa-envelope-o"/> {strings.sendMessageToDemonstratorWithComment}
	            </button>
            </>
        }
      </div>
    </div>
  );
};

export default connect(null, { openStatementCommentModal })(StatementDisplay);

const strings = new LocalizedStrings({
  fi: {
    demonstrator: 'Esittelijä',
    solver: 'Ratkaisija',
    notSigned: ' ei ole allekirjoittanut lausuntoa',
    signed: ' on allekirjoittanut lausunnon',
    posted: 'Lausunto on postitettu.',
    signStatement: 'Allekirjoita lausunto',
    sendMessageToSolver: 'Lähetä ratkaisijalle viesti "Lausunto katsottavana Sensessä"',
    sendMessageToDemonstrator: 'Lähetä esittelijälle viesti "Lausunto tarkastettu" ilman kommenttia',
    sendMessageToDemonstratorWithComment: 'Lähetä esittelijälle viesti "Lausunto tarkastettu" kommentin kanssa',
    messageToSolverSent: 'Viesti lähetetty ratkaisijalle',
    messageToDemonstratorSent: 'Viesti lähetetty esittelijälle',
    statementMailSent: 'Lausunto lähetetty',
    signatureDone: 'Allekirjoitettu',
    archiveWithoutSignature: 'Arkistoi ilman allekirjoitusta',
    statementArchived: 'Lausunto arkistoitu',
    status: {
		Open: 'Allekirjoituspyyntö on avoin',
	    RejectedByPresenter: 'Esittelijä on hylännyt allekirjoituspyynnön',
	    RejectedBySolver: 'Ratkaisija on hylännyt allekirjoituspyynnön',
	    PresenterSATUDoesNotMatch: 'Esittelijän SATU (Sähköinen asiointitunnus) ei vastaa allekirjoitusta.',
	    SolverSATUDoesNotMatch: 'Ratkaisijan SATU (Sähköinen asiointitunnus) ei vastaa allekirjoitusta.',
	    PresenterAndSolverSATUDoNotMatch: 'Esittelijan ja ratkaisijan SATU:t (Sähköinen asiointitunnus) eivät vastaa allekirjoitusta.',
	    Complete: 'Allekirjoituspyyntö on valmis',
	    StatementArchived: 'Asiakirja on siirretty tilaan käsitelty ilman sähköistä allekirjoitusta.',
    },
  },
  en: {
    demonstrator: 'Demonstrator',
    solver: 'Solver',
    notSigned: ' has not signed the statement',
    signed: ' has signed the statement',
    posted: 'Statement has been mailed.',
    signStatement: 'Sign statement',
    sendMessageToSolver: 'Send message to solver "Statement is available for review in Sense"',
    sendMessageToDemonstrator: 'Send message to demonstrator "Statement inspected" without comment',
    sendMessageToDemonstratorWithComment: 'Send message to demonstrator "Statement inspected" with comment',
    messageToSolverSent: 'Message has been sent to solver',
    messageToDemonstratorSent: 'Message has been sent to demonstrator',
    statementMailSent: 'Statement mailed',
    signatureDone: 'Signed',
    archiveWithoutSignature: 'Archive without a signature',
    statementArchived: 'Statement archived',
    status: {
		Open: 'Allekirjoituspyyntö on avoin',
	    RejectedByPresenter: 'Esittelijä on hylännyt allekirjoituspyynnön',
	    RejectedBySolver: 'Ratkaisija on hylännyt allekirjoituspyynnön',
	    PresenterSATUDoesNotMatch: 'Esittelijän SATU (Sähköinen asiointitunnus) ei vastaa allekirjoitusta.',
	    SolverSATUDoesNotMatch: 'Ratkaisijan SATU (Sähköinen asiointitunnus) ei vastaa allekirjoitusta.',
	    PresenterAndSolverSATUDoNotMatch: 'Esittelijan ja ratkaisijan SATU:t (Sähköinen asiointitunnus) eivät vastaa allekirjoitusta.',
	    Complete: 'Allekirjoituspyyntö on valmis',
	    StatementArchived: 'Asiakirja on siirretty tilaan käsitelty ilman sähköistä allekirjoitusta.',
    },
  },
  sv: {
    demonstrator: 'Demonstrant',
    solver: 'Lösare',
    notSigned: ' har inte skrivit under uttalandet',
    signed: ' har undertecknat uttalandet',
    posted: 'Uttalande har skickats.',
    signStatement: 'Signera uttalande',
    sendMessageToSolver: 'Skicka meddelande till lösaren "Utlåtande finns tillgängligt för granskning i Sense"',
    sendMessageToDemonstrator: 'Skicka meddelande till demonstrant "Utlåtande inspekterat" utan kommentar',
    sendMessageToDemonstratorWithComment: 'Skicka meddelande till demonstrant "Utlåtande inspekterat" med kommentar',
    messageToSolverSent: 'Meddelande har skickats till lösare',
    messageToDemonstratorSent: 'Meddelande har skickats till demonstrant',
    statementMailSent: 'Utlåtande postat',
    signatureDone: 'Signerad',
    archiveWithoutSignature: 'Arkiv utan signatur',
    statementArchived: 'Uttalande arkiverat',
    status: {
		Open: 'Allekirjoituspyyntö on avoin',
	    RejectedByPresenter: 'Esittelijä on hylännyt allekirjoituspyynnön',
	    RejectedBySolver: 'Ratkaisija on hylännyt allekirjoituspyynnön',
	    PresenterSATUDoesNotMatch: 'Esittelijän SATU (Sähköinen asiointitunnus) ei vastaa allekirjoitusta.',
	    SolverSATUDoesNotMatch: 'Ratkaisijan SATU (Sähköinen asiointitunnus) ei vastaa allekirjoitusta.',
	    PresenterAndSolverSATUDoNotMatch: 'Esittelijan ja ratkaisijan SATU:t (Sähköinen asiointitunnus) eivät vastaa allekirjoitusta.',
	    Complete: 'Allekirjoituspyyntö on valmis',
	    StatementArchived: 'Asiakirja on siirretty tilaan käsitelty ilman sähköistä allekirjoitusta.',
    },
  }
});